export const upsellItems = () => {
    return JSON.parse(localStorage.getItem('upsellItems') || '[]').map((item) => {
        return item.parent_sku;
    });
};
